<template>
    <div class="scroll-wrapper">
        <button
            v-if="iconsPlacement === 'sides'"
            class="scroll-indicator scroll-indicator--left pl-0"
            @click="scrollLeft"
        >
            <i class="fas fa-chevron-left"></i>
        </button>
        <div class="scroll-container flex-grow-1" ref="scrollContainer">
            <div class="scroll-content" :class="containerClass">
                <slot></slot>
            </div>
        </div>
        <button
            v-if="iconsPlacement === 'sides'"
            class="scroll-indicator scroll-indicator--right pr-0"
            @click="scrollRight"
        >
            <i class="fas fa-chevron-right"></i>
        </button>
        <div v-if="iconsPlacement === 'floating'" class="scroll-indicators" :class="buttonsClass"  :style="{ backgroundColor: buttonsBackground }">
            <button
                class="scroll-indicator scroll-indicator--left"
                @click="scrollLeft"
                v-show="canScrollLeft"
            >
                <i class="fas fa-chevron-left"></i>
            </button>
            <button
                class="scroll-indicator scroll-indicator--right"
                @click="scrollRight"
            >
               <i class="fas fa-chevron-right"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HorizontalScroll',
    props: {
        buttonsBackground: {
            type: String,
            default: 'white'
        },
        buttonsClass: {
            type: String,
            default: 'shadow-sm'
        },
        iconsPlacement : {
            type: String,
            default: 'floating'
        },
        containerClass : {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            canScrollLeft: false
        };
    },
    mounted() {
        this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll);

        const activeItem = this.$refs.scrollContainer.querySelector('.active')

        if (activeItem) {
            activeItem.scrollIntoView()
        }
    },
    beforeDestroy() {
        this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.canScrollLeft = this.$refs.scrollContainer.scrollLeft > 0;
        },
        scrollLeft() {
            this.$refs.scrollContainer.scrollBy({left: -300, behavior: 'smooth'});
        },
        scrollRight() {
            this.$refs.scrollContainer.scrollBy({left: 300, behavior: 'smooth'});
        }
    }
}
</script>

<style scoped>
.scroll-wrapper {
    position: relative;
    overflow-y: visible;
    display: flex;
}

.scroll-container {
    overflow-x: auto;
    overflow-y: visible;
    white-space: nowrap;
    padding-right: 200px;
}

.scroll-content {
    display: inline-block;
}

/* Hide scrollbar */
.scroll-container::-webkit-scrollbar {
    display: none;
}

/* Floating scroll indicators */
.scroll-indicators {
    position: absolute;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
}

.scroll-indicator {
    padding: 5px 10px;
    outline: none;
    border: none;
    background-color: transparent;
    color: currentColor;
}

.scroll-indicator--left,
.scroll-indicator--right {
    margin-left: 5px;
}
</style>
